// import logo from './logo.svg';
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./component/login/Login";
import Dashboard from './component/dashboard/Dashbrd'
import Demochats from './component/dashboard/chat/Demochats'
import Cocdashboard from './component/dashboard/chat/codeofconduct/Cocdashboard'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Login />
              </>
            }
          />

          <Route
            path="/dashboard"
            element={
              <>
                <Dashboard />
              </>
            }
          />
          <Route
            path="/demochat"
            element={
              <>
                <Demochats />
              </>
            }
          />

          <Route
            path="/compliance"
            element={
              <>
                <Cocdashboard />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
